import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosConfig from '../../shared/utils/axios-config';
import cookies from 'js-cookie';
import { Spin, Descriptions, Card } from 'antd';
import './main-logging-details.scss';
import LoggingDetailsTable from '../../shared/components/logging-table/logging-details-table';

const RecordingList = () => {
	// FIX: Must match the name in App.js path='/rpa/main-logging/:loggingId'
	const { loggingId } = useParams();

	const [details, setDetails] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		document.title = 'Roxus | Main Logging Details';
		if (loggingId) {
			fetchMainLoggingDetails();
		}
	}, [loggingId]);

	const fetchMainLoggingDetails = async () => {
		try {
			setLoading(true);
			const response = await axiosConfig({
				method: 'get',
				url: `/api/rpa/main-loggings/${loggingId}`,
				headers: {
					Authorization: `Bearer ${cookies.get('access_token')}`,
				},
			});
			// Adjust response.data based on your actual API structure
			setDetails(response.data?.data || response.data);
		} catch (error) {
			console.error("Error fetching logging details:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='ocr-list-page'>
			<div className='ocr-title'>
				<span className='text'>MAIN LOGGING DETAILS</span>
			</div>

			<Spin spinning={loading}>
				{details && (
					<div className="details-summary-line">
						<span className="summary-item">
							<span className="label">Process:</span>
							<span className="value">{details.processName}</span>
						</span>
						<span className="summary-divider">|</span>
						<span className="summary-item">
							<span className="label">By:</span>
							<span className="value">{details.initiatedBy}</span>
						</span>
						<span className="summary-divider">|</span>
						<span className="summary-item">
							<span className="label">Comment:</span>
							<span className="value blue">{details.startComments || 'N/A'}</span>
						</span>
					</div>
				)}

				{/* Pass the correct ID to the table component */}
				<LoggingDetailsTable loggingId={loggingId} />
			</Spin>
		</div>
	);
};

export default RecordingList;
